import { useState } from 'react';
import { useIntl } from 'react-intl';

import css from 'src/utils/css';
import EvolucaoAplicacoes from './EvolucaoAplicacoes';
import NpsMapaCalor from './NpsMapaCalor';
import NpsPorPerguntaTabela from './NpsPorPerguntaTabela';
import NpsResultadoGeral from './NpsResultadoGeral';

const VIEW_RESPONSES = 'respostas';
const VIEW_HEAT_MAP = 'mapa-calor';
const VIEW_EVOLUTION = 'evolucao';

const classes = css`
  .viewSelector {
    background: #f2f4f7;
    border: 1px solid #e4e7ec;
    border-radius: 7px;
    display: inline-flex;
    margin-bottom: 16px;
    padding: 2px;
  }

  .viewButton {
    background: transparent;
    border: 0;
    border-radius: 5px;
    color: #475467;
    cursor: pointer;
    font-size: 12px;
    line-height: 20px;
    padding: 5px 12px;

    &:focus {
      box-shadow: 0 0 0 2px rgba(29, 119, 137, 0.28);
      outline: none;
    }
  }

  .activeViewButton {
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.14);
    color: #1d7789;
    font-weight: 600;
  }
`;

function NpsDashboard({
  dados,
  entidadeId,
  filtroEvolucao,
  filtros,
  recorrente,
  refreshToken,
  semRespostas,
}) {
  const intl = useIntl();
  const [activeView, setActiveView] = useState(VIEW_RESPONSES);

  const views = [
    {
      id: VIEW_RESPONSES,
      label: intl.formatMessage({
        id: 'labelRespostas',
      }),
    },
    {
      id: VIEW_HEAT_MAP,
      label: intl.formatMessage({
        id: 'labelMapaCalor',
      }),
    },
    ...(recorrente
      ? [
          {
            id: VIEW_EVOLUTION,
            label: intl.formatMessage({ id: 'labelEvolucaoAplicacoes' }),
          },
        ]
      : []),
  ];

  return (
    <div>
      <div
        aria-label={intl.formatMessage({
          id: 'labelVisualizacaoDashboardNps',
        })}
        className={classes.viewSelector}
        role="group"
      >
        {views.map((view) => {
          const isActive = activeView === view.id;

          return (
            <button
              aria-pressed={isActive}
              className={`${classes.viewButton} ${
                isActive ? classes.activeViewButton : ''
              }`}
              key={view.id}
              onClick={() => setActiveView(view.id)}
              type="button"
            >
              {view.label}
            </button>
          );
        })}
      </div>

      {activeView === VIEW_RESPONSES &&
        (semRespostas ? (
          <div className="text-muted text-center py-5">
            {intl.formatMessage({ id: 'labelDashboardNpsSemRespostas' })}
          </div>
        ) : (
          <>
            <NpsResultadoGeral dados={dados} />
            <NpsPorPerguntaTabela perguntas={dados?.perguntas} />
          </>
        ))}
      {activeView === VIEW_HEAT_MAP && (
        <NpsMapaCalor
          entidadeId={entidadeId}
          filtros={filtros}
          refreshToken={refreshToken}
        />
      )}
      {activeView === VIEW_EVOLUTION && recorrente && (
        <EvolucaoAplicacoes
          entidadeId={entidadeId}
          filtroEvolucao={filtroEvolucao}
          filtros={filtros}
          refreshToken={refreshToken}
          tipo="nps"
        />
      )}
    </div>
  );
}

export default NpsDashboard;
